/**
 * Does a payment row belong to a given booking?
 *
 * A deposit row is matched to its tenancy by, in order: the row's own
 * `booking_id` (linked), then `metadata.booking_id` (a fallback for rows
 * inserted before the row was linked). An UNLINKED row (neither set) still
 * belongs to the only booking on screen when there is exactly one — the
 * Payments tab and the admin tenant profile both assume this — but cannot be
 * attributed to any one of several concurrent bookings, so the caller decides
 * what an unmatched row counts as via `unmatchedFallback`.
 *
 * Shared so the single-booking financials card and the multi-booking list on
 * the tenant Dashboard cannot silently diverge on this rule again (#1326).
 */
export function depositRowMatchesBooking(
  payment: {
    booking_id?: string | number | null;
    metadata?: { booking_id?: string | number | null } | null;
  },
  bookingId: number | null,
  unmatchedFallback: boolean
): boolean {
  const linked =
    payment.booking_id != null && payment.booking_id !== ""
      ? Number(payment.booking_id)
      : null;
  const meta =
    payment.metadata?.booking_id != null && payment.metadata.booking_id !== ""
      ? Number(payment.metadata.booking_id)
      : null;
  if (linked !== null) return linked === bookingId;
  if (meta !== null) return meta === bookingId;
  return unmatchedFallback;
}
